import { render, staticRenderFns } from "./ProviderGames.vue?vue&type=template&id=ae61f73e&"
import script from "./ProviderGames.vue?vue&type=script&lang=js&"
export * from "./ProviderGames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports